export const RadioBooleanFormat = (value = 'false') => {
  if (value === 'true') {
    return value = 1;
  } else {
    return value = 0;
  }
};

export const formIsValid = (form, args = {}) => {
  return args.reportValidity
    ? reportValidity(form)
    : form.current.checkValidity();
};

export const reportValidity = ({ current }) => current.reportValidity();

export const getFieldsWithErrors = (form) => {
  const fieldsWithErrors = [];
  for (let pos = 0; pos < form.current.elements.length; pos++) {
    const element = form.current.elements[pos];
    if (!element.validity.valid) {
      fieldsWithErrors.push({ pos, element });
    }
  }
  return fieldsWithErrors;
};

export const getFieldsAmount = (form) => form.current.elements.length;

export const isTypeValid = (files, validTypes) => {
  let isValid = true;
  files.forEach((file) => {
    const valid = validTypes.replace(/ /g, '').split(',');
    if (valid.indexOf(file.type) === -1) {
      isValid = false;
    }
  });
  return isValid;
};

export const isSizeValid = (files, maxSize) => {
  let isValid = true;
  files.forEach((file) => {
    if (file.size > maxSize) {
      isValid = false;
    }
  });
  return isValid;
};
